"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Base color

var blackColor = exports.blackColor = "#212529";
var whiteColor = exports.whiteColor = "#fff";
var greyColor1 = exports.greyColor1 = "#f2f4f8";
var greyColor2 = exports.greyColor2 = "#5a5e65";
var darkBg = exports.darkBg = "#36444f";
var redColor = exports.redColor = "rgb(255, 67, 97)";
var blueColor = exports.blueColor = "#45a7fd";

// Header colors

var headerColor = exports.headerColor = "#36444f";
var footerColor = exports.footerColor = "#36444f";

//  Form Input colors

var formBg = exports.formBg = greyColor1;
var inputColor = exports.inputColor = "#495057";
var placeholderColor = exports.placeholderColor = inputColor;
var inputBg = exports.inputBg = "#fff";
var borderColor = exports.borderColor = "#e1e5e8";